import useTranslation from "next-translate/useTranslation"
import { useSelector } from 'react-redux'
import { Modal, ModalBody, ModalHeader } from "reactstrap"

import { IProject } from "@api/schema"
import { isFlyoutVisible } from "@redux/reducer/applicationStates"

import ProjectStateForm from "./ProjectStateForm"


interface IProps {
  project: IProject
  modalOpen: boolean
  onSubmit: (...args: any) => void
  toggle: () => void
}

/**
 * this component provides a modal to provide a form to change the status of a single project
 */
const ProjectStateModal: React.FC<IProps> = (props: IProps) => {
  const { project, modalOpen, onSubmit, toggle } = props
  const isVisible = useSelector(isFlyoutVisible)
  const { t } = useTranslation("common")

  return <Modal className={isVisible ? "flyout-is-visible" : ""} isOpen={modalOpen} toggle={toggle}>
    <ModalHeader>
      {t("page.user.projects.projectSettings")}
    </ModalHeader>
    <ModalBody>
      <ProjectStateForm
        onSubmit={onSubmit}
        toggle={toggle}
        project={project}
      />
    </ModalBody>
  </Modal>
}

export default ProjectStateModal
